import {all, fork ,call, put, takeEvery, takeLatest  } from 'redux-saga/effects'
import { push } from 'react-router-redux';
import NetworkHandler from '../net/NetworkHandler'
import StorageHandler from '../storage/StorageHandler';
import * as ACTIONS from '../containers/constants';
import { error ,success } from '../components/Alert/actions';
import {updateSettings, settingsSaveCompleted} from '../containers/Settings/actions';
import { createCipher } from 'crypto';
const storageHandler = new StorageHandler();



function* getSettings(action){

  const Network = new NetworkHandler();
  
    try{

      const response = yield Network.requestGetSettings(action.payload);
      
      if (!(response instanceof Error)) {
          yield put(
            updateSettings(
              response
            )
          )
        } else {

          yield put(
            error({
              message: `Unable to get settings. ${response}`,
            })
          );
        }
    }catch (errorMsg) {
        yield put(
            error({
             message: `Unable to load settings, please try again.${errorMsg}`,
            })
        );
    }
}

function* saveSettings(action) {
  const Network = new NetworkHandler();
  
    try{

      var settingsObject = {
        notifications: action.payload.notifications,
        invites: action.payload.invites,
        cryodex_id: action.payload.cryodex_id
      }

      const response = yield Network.requestSaveSettings(settingsObject);
      
      if (!(response instanceof Error)) {
          yield put(
            settingsSaveCompleted()
          )
          alert("Settings saved!");
        } else {

          yield put(
            error({
              message: `Unable to save settings. ${response}`,
            })
          );
        }
    }catch (errorMsg) {
        yield put(
            error({
             message: `Unable to save settings, please try again.${errorMsg}`,
            })
        );
    }
}

export default function* settingsSagas() {
  yield takeLatest(ACTIONS.SETTINGS_GET, getSettings);
  yield takeLatest(ACTIONS.SETTINGS_SAVE, saveSettings);
  
}

